module.exports = __webpack_public_path__ + "img/medium.9fec03ce.svg";